import PortalIdParser from 'PortalIdParser';
import userInfo from 'hub-http/userInfo';
export async function getCurrentUser() {
  PortalIdParser.get();
  const currentUser = await userInfo();
  return currentUser;
}
export async function refreshCurrentUser() {
  const currentUser = await userInfo({
    cached: false
  });
  return currentUser;
}